import { ArrowLeft, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

const MIRAITO_LOGO = "/images/assets/uxgokohu-miwrite-match-logo.svg";
const KANSYUU_LOGO = "/images/assets/q2rb37r3-kansyuu-logo.svg";
const CAREER_LOGO = "/images/assets/31t5bblc-2-career-yoko.png";
const TEAMS_LOGO = "/images/assets/caj9n5l0-TEAMS-yoko.png";

export default function BusinessPage() {
  return (
    <div className="pt-16 md:pt-20 min-h-screen bg-white" data-testid="business-page">
      {/* Back Link */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 transition-colors duration-200"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Home</span>
        </Link>
      </div>

      {/* Header */}
      <section className="py-12 md:py-20 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="font-en text-sm font-semibold text-[#FF4D00] tracking-widest mb-4">
            What We Match
          </p>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Businesses
          </h1>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl leading-relaxed">
            IT&Pluckticeは、挑戦者の成長基盤となる複数事業を展開しています。
          </p>
        </div>
      </section>

      {/* Talent Matching Section - Main Business */}
      <section className="py-16 md:py-20 border-b border-gray-100" data-testid="talent-matching-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="mb-12">
            <p className="font-en text-sm font-semibold text-[#FF4D00] tracking-widest mb-4">
              MAIN BUSINESS
            </p>
            <h2 className="font-en text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Talent Matching
            </h2>
            <p className="text-base text-gray-600 max-w-xl">
              専門性の高い人材と企業を結び、<br />
              最適なマッチングを創出。
            </p>
          </div>

          {/* Service Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* ミライトマッチ */}
            <div 
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-500"
              data-testid="miraito-match-card"
            >
              <div className="mb-6">
                <img 
                  src={MIRAITO_LOGO} 
                  alt="ミライトマッチ" 
                  className="h-10 w-auto"
                />
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                記事を発注したい企業と専門ライターをマッチング。
                高品質なコンテンツ制作をサポートします。
              </p>
              <a
                href="https://miwrite-match.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-medium text-[#FF4D00] hover:text-[#E64500] transition-colors duration-200"
                data-testid="miraito-match-link"
              >
                <span>サイトを見る</span>
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>

            {/* 記事監修マッチ */}
            <div 
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-500"
              data-testid="kansyuu-match-card"
            >
              <div className="mb-6">
                <img 
                  src={KANSYUU_LOGO} 
                  alt="記事監修マッチ" 
                  className="h-10 w-auto"
                />
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                専門家に依頼・発注できる記事監修サービス。
                コンテンツの信頼性を高めます。
              </p>
              <a
                href="https://kansyuu.miwrite-match.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-medium text-[#FF4D00] hover:text-[#E64500] transition-colors duration-200"
                data-testid="kansyuu-match-link"
              >
                <span>サイトを見る</span>
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Career Matching Section */}
      <section className="py-16 md:py-20 border-b border-gray-100" data-testid="career-matching-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="mb-12">
            <h2 className="font-en text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Career Matching
            </h2>
            <p className="text-base text-gray-600 max-w-xl">
              企業と個人の持続的な成長を実現する<br />
              人材紹介事業。
            </p>
          </div>

          <div className="max-w-xl">
            {/* ミライトマッチキャリア */}
            <div 
              className="bg-gray-50 rounded-2xl p-8"
              data-testid="career-card"
            >
              <div className="mb-6">
                <img 
                  src={CAREER_LOGO} 
                  alt="ミライトマッチキャリア" 
                  className="h-10 w-auto"
                />
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                ライターのキャリアを拓く転職エージェント。
                専門性を活かしたキャリア形成をサポートします。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Growth Matching Section */}
      <section className="py-16 md:py-20" data-testid="growth-matching-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="mb-12">
            <h2 className="font-en text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Growth Matching
            </h2>
            <p className="text-base text-gray-600 max-w-xl">
              企業が抱えるマーケティング課題に、<br />
              適切なソリューションを提供。
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* ミライトマッチTEAMS */}
            <div 
              className="bg-gray-50 rounded-2xl p-8"
              data-testid="teams-card"
            >
              <div className="mb-6">
                <img 
                  src={TEAMS_LOGO} 
                  alt="ミライトマッチTEAMS" 
                  className="h-10 w-auto"
                />
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                戦略設計から実行まで、チーム体制で企業の成長を支援。
                マーケティングの課題解決に伴走します。
              </p>
            </div>

            {/* バズマッチ */}
            <div 
              className="bg-gray-50 rounded-2xl p-8"
              data-testid="buzzmatch-card"
            >
              <div className="mb-6">
                <h3 className="text-xl font-bold text-gray-900">バズマッチ</h3>
                <p className="text-xs text-gray-500 mt-1">関連会社</p>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                宿泊施設に特化したマーケティング支援。
                施設の集客力向上をサポートします。
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
